import React from 'react'
import { Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import CustomizedSwitch from 'src/components/customized-switch'
import styles from '../styles'

const PageDetailsToggle = ({ classes, showAllPageDetails, onToggle }) => {
  return (
    <div className={classes.pageDetails}>
      <Typography fontSize={14} fontWeight={500}>
        Page details
      </Typography>
      <div className={classes.pageDetailsSwitch}>
        <Typography fontSize={14} fontWeight={400}>
          Show all page details
        </Typography>
        <CustomizedSwitch checked={showAllPageDetails} onChange={onToggle} />
      </div>
    </div>
  )
}

export default withStyles(styles)(PageDetailsToggle)
